import React, { useCallback, useMemo, useState, useEffect } from "react";
import { Position, Handle } from "@xyflow/react";
import "@xyflow/react/dist/style.css";

const CustomNode = ({ id, data, style }) => {
  return (
    <div 
      style={{ 
        ...style,
        overflow: "hidden",
        pointerEvents: "all",
      }}
    >
      <Handle
        type="target"
        position={data.isGroup ? Position.Left : Position.Top}
        id={`top-${id}`}
        style={
          !data.isGroup
            ? { marginTop: "-25px" }
            : { marginTop: "15px", marginLeft: "5px" }
        }
      />
      <div
        className="node-label"
        style={{
          whiteSpace: "pre-line",
          textAlign: "center",
          fontWeight: data.isGroup ? 600 : 400,
          maxHeight: "60px",
          overflowY: "auto",
        }}
        onWheelCapture={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {data.label.replace(/\\n/g, "\n")}
      </div>
      <Handle
        type="source"
        position={data.isGroup ? Position.Right : Position.Bottom}
        id={`bottom-${id}`}
        style={
          !data.isGroup
            ? { marginTop: "55px" }
            : { marginTop: "15px", marginRight: "5px" }
        }
      />
    </div>
  );
};

export default CustomNode;
